/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PolicyNameNumber
 */
export interface PolicyNameNumber {
    /**
     * 
     * @type {string}
     * @memberof PolicyNameNumber
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyNameNumber
     */
    groupName?: string | null;
}

/**
 * Check if a given object implements the PolicyNameNumber interface.
 */
export function instanceOfPolicyNameNumber(value: object): value is PolicyNameNumber {
    return true;
}

export function PolicyNameNumberFromJSON(json: any): PolicyNameNumber {
    return PolicyNameNumberFromJSONTyped(json, false);
}

export function PolicyNameNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolicyNameNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
    };
}

export function PolicyNameNumberToJSON(json: any): PolicyNameNumber {
    return PolicyNameNumberToJSONTyped(json, false);
}

export function PolicyNameNumberToJSONTyped(value?: PolicyNameNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policyNumber': value['policyNumber'],
        'groupName': value['groupName'],
    };
}

